import React from 'react';
import { EntryForm } from './EntryForm';

export function CreateEntry() {
  return <EntryForm mode="create" />;
}